import React from 'react'
import { Grid, Typography } from '@mui/material'

import ProfileFormHeader from '../ProfileFormHeader'

import { ProfileFormThankYouIcon } from 'assets/icons'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    minHeight: '100vh',
  },
  content: {
    width: 720,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 20,

    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
}))

const ProfileFormThankYou = () => {
  const classes = useStyles()
  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      className={classes.root}
    >
      <ProfileFormHeader />
      <Grid className={classes.content} gap={3}>
        <ProfileFormThankYouIcon sx={{ width: 120, height: 120 }} />

        <Typography
          fontSize="36px"
          fontWeight="700"
          textAlign="center"
          lineHeight="1.05"
        >
          Thank you for submitting your application to join the Hue Community!
        </Typography>

        <Typography textAlign="center">
          Sit back, relax, and hopefully you’ll make it! If you do not hear
          back, then you were not admitted in this round. But, don’t worry if
          you don’t get in straight away. There are limited spots, and we review
          applications on a rolling basis.
        </Typography>
      </Grid>
    </Grid>
  )
}

export default ProfileFormThankYou
